var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "soli-round pa-0", attrs: { flat: "" } },
    [
      _c(
        "v-container",
        { staticClass: "px-3", attrs: { fluid: "" } },
        [
          !_vm.attendances
            ? _c("v-skeleton-loader", {
                staticClass: "mb-6 pl-1 pt-2",
                staticStyle: { "max-width": "600px" },
                attrs: {
                  type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line,list-item-avatar-three-line",
                  boilerplate: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.attendances
            ? _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.attendances,
                  search: _vm.search,
                  loading: _vm.loading,
                  "disable-sort": _vm.$vuetify.breakpoint.xs,
                  "group-by": "lesson.id",
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  "no-data-text": "No lessons found",
                },
                on: {
                  "click:row": function ($event) {
                    return _vm.$log($event.id)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `group.header`,
                      fn: function ({ group, items, isOpen, toggle }) {
                        return [
                          _c("th", { attrs: { colspan: "1" } }, [
                            _c(
                              "tr",
                              [
                                items[0]
                                  ? _c("AttendanceDate", {
                                      attrs: {
                                        date: items[0].lesson.starts_at,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { colspan: "1" } }, [
                            _c("tr", [
                              items[0]
                                ? _c(
                                    "div",
                                    { staticClass: "py-4" },
                                    [
                                      _c("AttendanceInfo", {
                                        attrs: { attendance: items[0] },
                                      }),
                                      _vm._v(" "),
                                      _c("AttendanceTitle", {
                                        attrs: { attendance: items[0] },
                                      }),
                                      _vm._v(" "),
                                      _c("AttendanceLesson", {
                                        attrs: { lesson: items[0].lesson },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.lesson.starts_at`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceDate", {
                            attrs: { date: item.lesson.starts_at },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.lesson.details`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "py-4" },
                            [
                              _c("AttendanceInfo", {
                                attrs: { attendance: item },
                              }),
                              _vm._v(" "),
                              _c("AttendanceTitle", {
                                attrs: { attendance: item },
                              }),
                              _vm._v(" "),
                              _c("AttendanceLesson", {
                                attrs: { lesson: item.lesson },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.purchaseOption.name`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceOption", {
                            attrs: {
                              attendance: item,
                              purchaseOption: item.purchaseOption,
                            },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.status`,
                      fn: function ({ item }) {
                        return [
                          _c("AttendanceStatus", {
                            attrs: { attendance: item, student: _vm.user },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }